/**
 * Server Error Response Model
 *
 * As described here: https://thebioagency.atlassian.net/wiki/display/ARROW/AJAX
 *
 * This model should be built from the `{ error: { ... } }` property in the response
 *
 */
'use strict';

var Backbone = require('backbone'),
  globalisation = require('../utilities/globalisation'),

  ServerErrorResponseModel = Backbone.Model.extend({

    defaults: function() {
      return {
        level: 'Error',
        type: null,
        title: globalisation.pluraliseAndTranslate('commonValidation', 'defaultErrorMessage'),
        messages: []
      };
    }

  }, {
    createFromXHR: function(response) {
      if (response && response.responseJSON) {
        return new ServerErrorResponseModel(response.responseJSON.error);
      } else {
        return new ServerErrorResponseModel();
      }
    }
  });

module.exports = ServerErrorResponseModel;



// WEBPACK FOOTER //
// ./assets/js/ServerErrorResponseModel.js